<script>
import {HorizontalBar} from "vue-chartjs";

export default {
  extends: HorizontalBar,
  name: "chart-top-client",
  props: {
    chartData: {
      type: Object,
      default: null
    },
    options: {
      type: Object,
      default: null
    }
  },
  mounted() {
    this.renderChart(this.chartData, this.options)
  }
}
</script>
